import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SearchDataService } from '../../services/search/search-data.service';
import { ENTITY_NAMES } from '../../constants/api-constants';
import { Subject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-relatedto-data-input',
  templateUrl: './relatedto-data-input.component.html',
  styleUrls: ['./relatedto-data-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RelatedtoDataInputComponent),
      multi: true
    }
  ]
})
export class RelatedtoDataInputComponent implements OnInit, ControlValueAccessor {
  allResultsData: any[] = [];
  filteredResults: any[] = [];
  searchText: string = '';

  @Input() selectedType: string = '';
  @Input() disableType: boolean = false;
  @Input() searchOnlyClients: boolean = false;
  @Input() searchOnlyLeads: boolean = false;

  @Output() personData: EventEmitter<any> = new EventEmitter();

  private searchSubject = new Subject<string>();

  selectedItem: any;
  private onChange!: (value: any) => void;
  private onTouched!: () => void;

  constructor(private _searchDataService: SearchDataService,
    private _elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.searchSubject.pipe(
      debounceTime(300), // wait 300ms after typing stops
      distinctUntilChanged(),
      switchMap((searchText: string) => {
        if (!searchText.trim() || searchText.length < 2) return of([]);

        if (this.searchOnlyLeads) {
          return this._searchDataService.searchPersonByType(ENTITY_NAMES.LEAD, searchText);
        } else if (this.searchOnlyClients) {
          return this._searchDataService.searchPersonByType(ENTITY_NAMES.CLIENT, searchText);
        } else {
          return this._searchDataService.searchDataInModule(ENTITY_NAMES.PERSON, searchText);
        }
      })
    ).subscribe((data: any[]) => {
      this.filteredResults = (data || []).map(item => ({
        ...item,
        displayName: `${item.firstName} ${item.lastName} (${item.leadId})`
      }));
    });
  }

  writeValue(value: any): void {
    if (value) {
      this.selectedItem = value;
      this.searchText = `${value.firstName} ${value.lastName} (${value.leadId})`;
      this.selectedType = value.category;
    } else {
      this.selectedItem = null;
      this.searchText = '';
      this.selectedType = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disableType = isDisabled;
  }

  onSearchTextChange(): void {
    this.searchSubject.next(this.searchText);
  }

  selectItem(item: any): void {
    this.selectedItem = item;
    this.searchText = `${item.firstName} ${item.lastName} (${item.leadId})`;
    this.selectedType = item.category;
    this.filteredResults = [];
    this.personData.emit(item);
    this.onChange(item);
    this.onTouched();
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this._elementRef.nativeElement.contains(targetElement)) {
      // this.dropdownVisible = false;
      this.filteredResults = [];
    }
  }
}
